import {default as Component} from './SignUpControl'
import {showModalPopup} from '../../redux/actions'
import {connect} from 'react-redux'
import {MODAL_POPUP_ID} from '../../redux/const'

const SignUpControl = connect(
	(state) => ({
		visible: !state.login.isLoggedIn
	}),
	(dispatch) => ({
		click: () => {
			dispatch(showModalPopup(MODAL_POPUP_ID.SIGN_UP))
		}
	})
)(Component)

SignUpControl.defaultProps = {
	visible: null,
	click: null,
}

export default SignUpControl


// WEBPACK FOOTER //
// ./src/components/SignUpControl/index.js